var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLock = function SvgIconLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeWidth: 1.4,
    d: "M1.668 13.334c0-2.357 0-3.536.732-4.268s1.91-.732 4.268-.732h6.667c2.357 0 3.535 0 4.267.732s.733 1.911.733 4.268 0 3.535-.733 4.268c-.732.732-1.91.732-4.267.732H6.668c-2.357 0-3.536 0-4.268-.732-.732-.733-.732-1.911-.732-4.268Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M5 8.333V6.666a5 5 0 1 1 10 0v1.667"
  })));
};
export default SvgIconLock;